import { Terms } from "@/pages/legal";
export default Terms;
